import { MODELS_SUBS, type ModelsSub } from './modelsStages';

// THE PHASES THAT HAVE SUBPHASES, and which one is open: each remembers it in a place slot (see
// lastPlace), read back through the rule below. One rule per phase, used by the phase itself and by
// whatever else asks which subphase is open — the memory report (see AppScreenMemory), whose table
// in Phase 7 also lists them with their labels.
//
// Keyed by the phase's id in viewerPipelines.
export const stepsView = (saved: string) => (saved === 'substeps' || saved === 'rules' ? saved : 'overview');
// The hardware table was a subphase of its own: it is the hardware's first half now. And placing
// the covers is the Assembly phase's: it makes no model, it says where finished ones go.
export const modelsSub = (saved: string): ModelsSub => (saved === 'interactions' ? 'hardware'
  : saved === 'covers' ? 'components'
    : MODELS_SUBS.find((s) => s === saved) ?? 'product');

export const SUBPHASES: Record<string, { slot: string; of: (saved: string) => string; subs: { id: string; labelKey: string }[] }> = {
  'notice-step-4': {
    slot: 'steps', of: stepsView,
    subs: [
      { id: 'overview', labelKey: 'notice.steps.subOverview' }, { id: 'substeps', labelKey: 'notice.steps.subSteps' },
      { id: 'rules', labelKey: 'notice.steps.subRules' },
    ],
  },
  'notice-step-7': {
    slot: 'modelsSub', of: modelsSub,
    subs: [
      { id: 'product', labelKey: 'notice.models.subProduct' }, { id: 'tools', labelKey: 'notice.models.subTools' },
      { id: 'hardware', labelKey: 'notice.models.subHardware' }, { id: 'components', labelKey: 'notice.models.subComponents' },
      { id: 'single', labelKey: 'notice.models.subSingle' },
    ],
  },
};

// The key a phase or subphase is reported and listed under: the phase's id, and the subphase's.
export const appScreenKey = (phaseId: string, sub?: string) => (sub ? `${phaseId}:${sub}` : phaseId);
